// カード取得演出とシャッフル演出

// スタイル注入
export function injectCardEffectStyles(): void {
  if (document.getElementById('card-effect-styles')) return;

  const style = document.createElement('style');
  style.id = 'card-effect-styles';
  style.textContent = `
    /* カード取得演出 */
    @keyframes cardAcquire {
      0% {
        transform: scale(0.3) rotateY(180deg);
        opacity: 0;
        filter: brightness(2) blur(10px);
      }
      30% {
        transform: scale(1.3) rotateY(90deg);
        opacity: 1;
        filter: brightness(1.5) blur(2px);
      }
      50% {
        transform: scale(1.1) rotateY(0deg);
        filter: brightness(1.2) blur(0);
      }
      70% {
        transform: scale(1.05);
      }
      100% {
        transform: scale(1);
        filter: brightness(1);
      }
    }

    @keyframes cardGlow {
      0%, 100% {
        box-shadow: 0 0 20px var(--glow-color, #00d4ff),
                    0 0 40px var(--glow-color, #00d4ff),
                    inset 0 0 20px rgba(255,255,255,0.1);
      }
      50% {
        box-shadow: 0 0 30px var(--glow-color, #00d4ff),
                    0 0 60px var(--glow-color, #00d4ff),
                    0 0 80px var(--glow-color, #00d4ff),
                    inset 0 0 30px rgba(255,255,255,0.2);
      }
    }

    @keyframes particleBurst {
      0% {
        transform: translate(-50%, -50%) scale(0);
        opacity: 1;
      }
      100% {
        transform: translate(-50%, -50%) scale(2);
        opacity: 0;
      }
    }

    @keyframes floatUp {
      0% {
        transform: translateY(0) scale(1);
        opacity: 1;
      }
      100% {
        transform: translateY(-50px) scale(0.5);
        opacity: 0;
      }
    }

    @keyframes rarityShine {
      0% {
        background-position: -200% center;
      }
      100% {
        background-position: 200% center;
      }
    }

    .card-acquire-animation {
      animation: cardAcquire 0.6s cubic-bezier(0.34, 1.56, 0.64, 1) forwards;
    }

    .card-glow-effect {
      animation: cardGlow 1s ease-in-out;
    }

    .card-particle {
      position: absolute;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      pointer-events: none;
    }

    .rarity-shine {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(
        90deg,
        transparent 0%,
        rgba(255,255,255,0.4) 50%,
        transparent 100%
      );
      background-size: 200% 100%;
      animation: rarityShine 0.8s ease-out;
      pointer-events: none;
      border-radius: inherit;
    }

    /* シャッフル演出 */
    @keyframes shuffleCard {
      0% {
        transform: translateX(0) translateY(0) rotateZ(0);
      }
      25% {
        transform: translateX(var(--shuffle-x, 30px)) translateY(var(--shuffle-y, -20px)) rotateZ(var(--shuffle-r, 15deg));
      }
      50% {
        transform: translateX(calc(var(--shuffle-x, 30px) * -0.5)) translateY(var(--shuffle-y, -20px)) rotateZ(calc(var(--shuffle-r, 15deg) * -1));
      }
      75% {
        transform: translateX(calc(var(--shuffle-x, 30px) * 0.3)) translateY(calc(var(--shuffle-y, -20px) * 0.5)) rotateZ(calc(var(--shuffle-r, 15deg) * 0.5));
      }
      100% {
        transform: translateX(0) translateY(0) rotateZ(0);
      }
    }

    @keyframes deckPulse {
      0%, 100% {
        transform: scale(1);
      }
      50% {
        transform: scale(1.05);
      }
    }

    @keyframes cardFlyToDeck {
      0% {
        transform: translate(0, 0) scale(1) rotateY(0);
        opacity: 1;
      }
      50% {
        transform: translate(var(--fly-x, 0), var(--fly-y, -100px)) scale(0.6) rotateY(180deg);
        opacity: 0.8;
      }
      100% {
        transform: translate(var(--end-x, 0), var(--end-y, 0)) scale(0.3) rotateY(360deg);
        opacity: 0;
      }
    }

    .shuffle-animation {
      animation: shuffleCard 0.4s ease-in-out;
    }

    .deck-pulse {
      animation: deckPulse 0.3s ease-in-out;
    }

    .card-fly-to-deck {
      animation: cardFlyToDeck 0.5s ease-in forwards;
      position: fixed;
      z-index: 1000;
      pointer-events: none;
    }

    /* カード削除演出 */
    @keyframes cardRemove {
      0% {
        transform: scale(1) rotateX(0);
        opacity: 1;
      }
      30% {
        transform: scale(1.1) rotateX(0);
      }
      100% {
        transform: scale(0) rotateX(90deg) translateY(50px);
        opacity: 0;
      }
    }

    .card-remove-animation {
      animation: cardRemove 0.4s ease-in forwards;
    }

    /* オーバーレイ */
    .card-effect-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.7);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 999;
      opacity: 0;
      transition: opacity 0.3s;
    }

    .card-effect-overlay.visible {
      opacity: 1;
    }

    .acquired-card-display {
      transform: scale(1.5);
    }

    /* レアリティ別パーティクル色 */
    .particle-common { background: #aaaaaa; }
    .particle-rare { background: #3498db; }
    .particle-epic { background: #9b59b6; }
    .particle-legendary { 
      background: linear-gradient(45deg, #ffd700, #ff6b6b, #ffd700);
      width: 15px;
      height: 15px;
    }
  `;
  document.head.appendChild(style);
}

// レアリティに応じたグロー色
function getGlowColor(rarity: string): string {
  switch (rarity) {
    case 'legendary': return '#ffd700';
    case 'epic': return '#9b59b6';
    case 'rare': return '#3498db';
    default: return '#00d4ff';
  }
}

// パーティクル生成
function createParticles(
  container: HTMLElement,
  count: number,
  rarity: string
): void {
  const rect = container.getBoundingClientRect();
  const centerX = rect.width / 2;
  const centerY = rect.height / 2;

  for (let i = 0; i < count; i++) {
    const particle = document.createElement('div');
    particle.className = `card-particle particle-${rarity}`;
    
    const angle = (i / count) * Math.PI * 2;
    const distance = 50 + Math.random() * 50;
    const endX = Math.cos(angle) * distance;
    const endY = Math.sin(angle) * distance;
    
    particle.style.cssText = `
      left: ${centerX}px;
      top: ${centerY}px;
      transform: translate(-50%, -50%);
      animation: particleBurst 0.6s ease-out forwards;
      --end-x: ${endX}px;
      --end-y: ${endY}px;
    `;

    // カスタムアニメーション
    particle.animate([
      { transform: 'translate(-50%, -50%) scale(1)', opacity: 1 },
      { transform: `translate(calc(-50% + ${endX}px), calc(-50% + ${endY}px)) scale(0)`, opacity: 0 }
    ], {
      duration: 600,
      easing: 'ease-out'
    });

    container.appendChild(particle);
    setTimeout(() => particle.remove(), 600);
  }
}

// カード取得演出
export async function playCardAcquireEffect(
  cardElement: HTMLElement,
  rarity: string = 'common'
): Promise<void> {
  injectCardEffectStyles();

  const glowColor = getGlowColor(rarity);
  cardElement.style.setProperty('--glow-color', glowColor);
  
  // アニメーションクラス追加
  cardElement.classList.add('card-acquire-animation');
  
  // パーティクル数 (レアリティで変化)
  const particleCount = rarity === 'legendary' ? 20 : 
                        rarity === 'epic' ? 15 : 
                        rarity === 'rare' ? 10 : 6;
  
  // パーティクル生成
  setTimeout(() => {
    createParticles(cardElement, particleCount, rarity);
  }, 200);

  // グロー効果
  if (rarity !== 'common') {
    cardElement.classList.add('card-glow-effect');
  }

  // レアリティシャイン (rare以上)
  if (rarity !== 'common') {
    const shine = document.createElement('div');
    shine.className = 'rarity-shine';
    cardElement.style.position = 'relative';
    cardElement.appendChild(shine);
    setTimeout(() => shine.remove(), 800);
  }

  // アニメーション完了待ち
  await new Promise((resolve) => setTimeout(resolve, 600));
  
  cardElement.classList.remove('card-acquire-animation', 'card-glow-effect');
}

// カードがデッキに飛んでいく演出
export async function playCardFlyToDeck(
  sourceElement: HTMLElement,
  targetElement: HTMLElement
): Promise<void> {
  injectCardEffectStyles();

  const sourceRect = sourceElement.getBoundingClientRect();
  const targetRect = targetElement.getBoundingClientRect();

  // クローン作成
  const clone = sourceElement.cloneNode(true) as HTMLElement;
  clone.style.cssText = `
    position: fixed;
    left: ${sourceRect.left}px;
    top: ${sourceRect.top}px;
    width: ${sourceRect.width}px;
    height: ${sourceRect.height}px;
    z-index: 1000;
    pointer-events: none;
    --fly-x: ${(targetRect.left - sourceRect.left) / 2}px;
    --fly-y: -100px;
    --end-x: ${targetRect.left + targetRect.width / 2 - sourceRect.left - sourceRect.width / 2}px;
    --end-y: ${targetRect.top + targetRect.height / 2 - sourceRect.top - sourceRect.height / 2}px;
  `;
  clone.classList.add('card-fly-to-deck');
  
  document.body.appendChild(clone);

  // ターゲットにパルス効果
  targetElement.classList.add('deck-pulse');

  await new Promise((resolve) => setTimeout(resolve, 500));
  
  clone.remove();
  targetElement.classList.remove('deck-pulse');
}

// シャッフル演出
export async function playShuffleEffect(
  deckElement: HTMLElement,
  intensity: number = 3
): Promise<void> {
  injectCardEffectStyles();

  // 複数のカード影を生成してシャッフル感を出す
  const cards: HTMLElement[] = [];
  const cardCount = 5;

  for (let i = 0; i < cardCount; i++) {
    const card = document.createElement('div');
    card.style.cssText = `
      position: absolute;
      width: 60px;
      height: 84px;
      background: linear-gradient(135deg, #2a2a4a, #1a1a3a);
      border: 2px solid #444;
      border-radius: 8px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
      --shuffle-x: ${(Math.random() - 0.5) * 40 * intensity}px;
      --shuffle-y: ${(Math.random() - 0.5) * 30 * intensity}px;
      --shuffle-r: ${(Math.random() - 0.5) * 20 * intensity}deg;
      z-index: ${i};
    `;
    
    // カード裏面デザイン
    card.innerHTML = `
      <div style="
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, 
          rgba(0, 212, 255, 0.1) 0%,
          rgba(0, 255, 136, 0.1) 100%
        );
        border-radius: 6px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 1.5rem;
      ">⚔️</div>
    `;
    
    deckElement.appendChild(card);
    cards.push(card);
  }

  // シャッフルアニメーション実行
  for (let round = 0; round < intensity; round++) {
    for (const card of cards) {
      card.style.setProperty('--shuffle-x', `${(Math.random() - 0.5) * 40 * intensity}px`);
      card.style.setProperty('--shuffle-y', `${(Math.random() - 0.5) * 30 * intensity}px`);
      card.style.setProperty('--shuffle-r', `${(Math.random() - 0.5) * 20 * intensity}deg`);
      card.classList.add('shuffle-animation');
    }
    
    await new Promise((resolve) => setTimeout(resolve, 400));
    
    for (const card of cards) {
      card.classList.remove('shuffle-animation');
    }
  }

  // カード削除
  for (const card of cards) {
    card.remove();
  }
}

// デッキ構築完了時のシャッフル演出 (より派手)
export async function playDeckCompleteEffect(
  deckElement: HTMLElement,
  cardCount: number
): Promise<void> {
  injectCardEffectStyles();

  // デッキ表示用コンテナ
  const container = document.createElement('div');
  container.style.cssText = `
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 1000;
    perspective: 1000px;
  `;

  // オーバーレイ
  const overlay = document.createElement('div');
  overlay.className = 'card-effect-overlay';
  document.body.appendChild(overlay);
  
  setTimeout(() => overlay.classList.add('visible'), 10);

  // カード束を表示
  const stackSize = Math.min(cardCount, 10);
  const cards: HTMLElement[] = [];

  for (let i = 0; i < stackSize; i++) {
    const card = document.createElement('div');
    card.style.cssText = `
      position: absolute;
      width: 80px;
      height: 112px;
      background: linear-gradient(135deg, #2a2a4a, #1a1a3a);
      border: 2px solid #00d4ff;
      border-radius: 10px;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%) translateZ(${i * 3}px);
      box-shadow: 0 2px 10px rgba(0,0,0,0.5);
    `;
    card.innerHTML = `
      <div style="
        width: 100%;
        height: 100%;
        background: linear-gradient(135deg, 
          rgba(0, 212, 255, 0.2) 0%,
          rgba(0, 255, 136, 0.2) 100%
        );
        border-radius: 8px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
      ">⚔️</div>
    `;
    container.appendChild(card);
    cards.push(card);
  }

  document.body.appendChild(container);

  // カード枚数表示
  const countDisplay = document.createElement('div');
  countDisplay.style.cssText = `
    position: absolute;
    bottom: -60px;
    left: 50%;
    transform: translateX(-50%);
    color: #00d4ff;
    font-size: 1.5rem;
    font-weight: bold;
    text-shadow: 0 0 10px #00d4ff;
  `;
  countDisplay.textContent = `${cardCount} Cards`;
  container.appendChild(countDisplay);

  // シャッフルアニメーション
  for (let round = 0; round < 3; round++) {
    await new Promise((resolve) => setTimeout(resolve, 200));
    
    for (let i = 0; i < cards.length; i++) {
      const card = cards[i];
      const offsetX = (Math.random() - 0.5) * 100;
      const offsetY = (Math.random() - 0.5) * 60;
      const rotation = (Math.random() - 0.5) * 30;
      
      card.animate([
        { transform: card.style.transform },
        { transform: `translate(calc(-50% + ${offsetX}px), calc(-50% + ${offsetY}px)) rotateZ(${rotation}deg) translateZ(${i * 3}px)` },
        { transform: card.style.transform }
      ], {
        duration: 300,
        easing: 'ease-in-out'
      });
    }
  }

  // 収束アニメーション
  await new Promise((resolve) => setTimeout(resolve, 500));
  
  for (let i = 0; i < cards.length; i++) {
    cards[i].animate([
      { transform: cards[i].style.transform },
      { transform: `translate(-50%, -50%) translateZ(0) scale(0.9)` }
    ], {
      duration: 200,
      easing: 'ease-out',
      fill: 'forwards'
    });
  }

  // 完了メッセージ
  const completeMsg = document.createElement('div');
  completeMsg.style.cssText = `
    position: absolute;
    top: -80px;
    left: 50%;
    transform: translateX(-50%);
    color: #00ff88;
    font-size: 1.8rem;
    font-weight: bold;
    text-shadow: 0 0 20px #00ff88;
    opacity: 0;
    animation: floatUp 1s ease-out reverse;
  `;
  completeMsg.textContent = '✓ READY!';
  container.appendChild(completeMsg);
  
  completeMsg.animate([
    { opacity: 0, transform: 'translateX(-50%) translateY(20px)' },
    { opacity: 1, transform: 'translateX(-50%) translateY(0)' }
  ], {
    duration: 300,
    fill: 'forwards'
  });

  // クリーンアップ
  await new Promise((resolve) => setTimeout(resolve, 1500));
  
  overlay.classList.remove('visible');
  await new Promise((resolve) => setTimeout(resolve, 300));
  
  overlay.remove();
  container.remove();
}

// カード削除演出
export async function playCardRemoveEffect(
  cardElement: HTMLElement
): Promise<void> {
  injectCardEffectStyles();
  
  cardElement.classList.add('card-remove-animation');
  
  await new Promise((resolve) => setTimeout(resolve, 400));
}

// 複数カード同時取得演出 (プール選択時)
export async function playMultiCardAcquireEffect(
  cards: { element: HTMLElement; rarity: string }[],
  staggerDelay: number = 100
): Promise<void> {
  injectCardEffectStyles();

  const promises: Promise<void>[] = [];

  for (let i = 0; i < cards.length; i++) {
    const card = cards[i];
    const delay = i * staggerDelay;

    const promise = new Promise<void>((resolve) => {
      setTimeout(async () => {
        await playCardAcquireEffect(card.element, card.rarity);
        resolve();
      }, delay);
    });

    promises.push(promise);
  }

  await Promise.all(promises);
}
